import LegalDoc from "@/components/LegalDoc";
import { PRIVACY } from "@/data/legal";

export default function Privacy() {
  return <LegalDoc doc={PRIVACY} crossLink={{ pre: "See also our", to: "/terms", label: "Terms of Use" }} />;
}
